var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeBar),expression:"closeBar"}],staticClass:"wrapper",class:{
		['background-' + _vm.color]: true,
		active: _vm.active
	}},[_c('div',{staticClass:"search-bar"},[_c('input',{ref:"search-text",attrs:{"type":"text","placeholder":"Cerca"},on:{"click":_vm.openBar,"keypress":_vm.onKeyPress}}),_c('v-icon',{staticClass:"magnify",attrs:{"color":"white"},on:{"click":_vm.onSearchClick}},[_vm._v(" mdi-magnify ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }